/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Location_LabelInputs */

const en_media_import_location_label = /** @type {(inputs: Media_Import_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media Location`)
};

const fr_media_import_location_label = /** @type {(inputs: Media_Import_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emplacement du media`)
};

const de_media_import_location_label = /** @type {(inputs: Media_Import_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medienstandort`)
};

const it_media_import_location_label = /** @type {(inputs: Media_Import_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione dei media`)
};

const ru_media_import_location_label = /** @type {(inputs: Media_Import_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Медиа-местоположение`)
};

const es_media_import_location_label = /** @type {(inputs: Media_Import_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubicación de los medios`)
};

const zh_cn2_media_import_location_label = /** @type {(inputs: Media_Import_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`媒体位置`)
};

const ja_media_import_location_label = /** @type {(inputs: Media_Import_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアの場所`)
};

const hi_media_import_location_label = /** @type {(inputs: Media_Import_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मीडिया स्थान`)
};

const pt_pt2_media_import_location_label = /** @type {(inputs: Media_Import_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Localização da mídia`)
};

/**
* | output |
* | --- |
* | "Media Location" |
*
* @param {Media_Import_Location_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_location_label = /** @type {((inputs?: Media_Import_Location_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Location_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_import_location_label(inputs)
	if (locale === "de") return de_media_import_location_label(inputs)
	if (locale === "it") return it_media_import_location_label(inputs)
	if (locale === "ru") return ru_media_import_location_label(inputs)
	if (locale === "es") return es_media_import_location_label(inputs)
	if (locale === "zh-CN") return zh_cn2_media_import_location_label(inputs)
	if (locale === "ja") return ja_media_import_location_label(inputs)
	if (locale === "hi") return hi_media_import_location_label(inputs)
	if (locale === "pt-PT") return pt_pt2_media_import_location_label(inputs)
	return en_media_import_location_label(inputs)
});